import { mapGetters, mapActions } from "vuex";
import { capitalize } from "@/common/functions";

export default {
    name: "FilterOptions",
    props: {
        buttonType: {
            type: String,
            default: "default"
        },
        grid: {
            type: String,
            default: "grid"
        },
        options: {
            type: Array,
            required: true
        },
        type: {
            type: String,
            default: "category"
        }
    },
    data() {
        return {
            filters: {
                pos: [],
                category: []
            }
        };
    },
    computed: {
        ...mapGetters("Login", ["user"]),
        ...mapGetters("ThesaurusFilter", [
            "getFiltersObj",
            "getActiveFiltersAmount",
            "getThesaurusHeadword"
        ])
    },
    watch: {
        "getFiltersObj.pos.active"() {
            this.filters.pos = [...this.getFiltersObj.pos.active];
        },
        "getFiltersObj.category.active"() {
            this.filters.category = [...this.getFiltersObj.category.active];
        }
    },
    methods: {
        ...mapActions("ThesaurusFilter", ["filterThesaurus"]),
        applyFilter() {
            this.filterThesaurus({
                filterType: this.type,
                filters: this.filters[this.type]
            });
        },
        filterSynonyms(name) {
            this.applyFilter();

            switch (this.type) {
                case "pos":
                    this.trackPartOfSpeech(name);
                    break;
                case "category":
                    this.trackCategoryFilter(name);
            }
        },
        getFilterTitle(filterName) {
            const word = this.getThesaurusHeadword;
            switch (filterName) {
                case "commonFilter":
                    return this.$t("thesaurusAltTextCommonFilter");
                case "uniqueFilter":
                    return this.$t("thesaurusAltTextUniqueFilter");
                case "ANTONYMS":
                    return this.$t("thesaurusAltTextAntonymsFilter");
                case "SYNONYMS":
                    return this.$t("thesaurusAltTextSynonymsFilter", { word });
                case "SEE_MORE":
                    return this.$t("thesaurusAltTextRelatedFilter", { word });
                case "IDIOMS":
                    return this.$t("thesaurusAltTextIdiomsFilter", { word });
                default: {
                    const pos = this.$t(filterName);
                    return this.$t("thesaurusAltTextPOS", { pos });
                }
            }
        },
        trackPartOfSpeech(pos) {
            const action = this.filters.pos.includes(pos) ? "Select" : "Deselect";
            const eventName = "Part of speech filter";
            this.$ga.event({
                eventCategory: eventName,
                eventAction: "Select part of speech"
            });
        },
        trackCategoryFilter(name) {
            const action = this.filters.category.includes(name) ? "Select" : "Deselect";
            switch (name) {
                case "commonFilter": {
                    const eventName = "Common words filter";
                    this.$ga.event({
                        eventCategory: eventName,
                        eventAction: "Show common words"
                    });
                    break;
                }
                case "uniqueFilter": {
                    const eventName = "Unique words filter";
                    this.$ga.event({
                        eventCategory: eventName,
                        eventAction: "Show unique words"
                    });
                    break;
                }
                default: {
                    const tName = this.$t(name);
                    const eventName = `${this.capitalize(tName)} filter`;
                    this.$ga.event({
                        eventCategory: eventName,
                        eventAction: `Show ${tName} words`
                    });
                }
            }
        },
        capitalize
    }
};



// WEBPACK FOOTER //
// ./src/components/Synonym/SynonymFilter/FilterOptions/FilterOptions.js